// ── Anxiety (GAD-5) ──────────────────────────────────────
export const ANXIETY_OPTIONS = [
  "Nada en absoluto",
  "Varios días",
  "Más de la mitad de los días",
  "Casi todos los días",
];

export const ANXIETY_ITEMS = [
  { id: "ansioso", label: "Me he sentido nervioso/a o ansioso/a" },
  { id: "relajar", label: "Me ha costado relajarme" },
  { id: "pensamientos", label: "He tenido pensamientos repetitivos o preocupaciones constantes" },
  { id: "irritable", label: "Me he sentido fácilmente irritable o alterado/a" },
  { id: "dormir", label: "He tenido dificultades para dormir o mantenerme dormido/a" },
];

// ── Stress/Burnout ───────────────────────────────────────
export const STRESS_OPTIONS = [
  "Nunca",
  "Rara vez",
  "A veces",
  "Frecuentemente",
  "Siempre",
];

export const STRESS_ITEMS = [
  { id: "carga", label: "Siento que mi carga diaria es excesiva" },
  { id: "desconectar", label: "Me cuesta desconectar de mis responsabilidades después de mi jornada" },
  { id: "agotado", label: "Me siento emocionalmente agotado/a al final del día" },
  { id: "frustrado", label: "Me siento frustrado/a o desmotivado/a con lo que hago" },
  { id: "tiempo", label: "Siento que no tengo tiempo para mí o para descansar" },
];

// ── Wellbeing ────────────────────────────────────────────
export const WELLBEING_OPTIONS = [
  "Nunca",
  "Rara vez",
  "A veces",
  "Frecuentemente",
  "Siempre",
];

export const WELLBEING_ITEMS = [
  { id: "proposito", label: "Siento que lo que hago tiene un propósito o valor" },
  { id: "apoyo", label: "Me siento acompañado/a o emocionalmente apoyado/a" },
  { id: "equilibrio", label: "Estoy satisfecho/a con el equilibrio entre mi vida personal y mis tareas" },
  { id: "reconectar", label: "Tengo momentos para reconectar conmigo y descansar" },
  { id: "gratitud", label: "Siento gratitud o disfruto pequeños momentos del día" },
];

// ── Classifications ──────────────────────────────────────
export function classifyAnxiety(score) {
  if (score <= 4) return { label: "Mínima", color: "#157346", key: "minimal" };
  if (score <= 9) return { label: "Leve", color: "#F9A01B", key: "mild" };
  if (score <= 14) return { label: "Moderada", color: "#C0453A", key: "moderate" };
  return { label: "Severa", color: "#C0453A", key: "severe" };
}

export function classifyStress(score) {
  if (score <= 5) return { label: "Bajo", color: "#157346", key: "low" };
  if (score <= 10) return { label: "Moderado", color: "#F9A01B", key: "moderate" };
  if (score <= 15) return { label: "Alto", color: "#C0453A", key: "high" };
  return { label: "Crítico", color: "#C0453A", key: "critical" };
}

export function classifyWellbeing(score) {
  if (score <= 5) return { label: "Bajo", color: "#C0453A", key: "low" };
  if (score <= 10) return { label: "Moderado", color: "#F9A01B", key: "moderate" };
  if (score <= 15) return { label: "Alto", color: "#157346", key: "high" };
  return { label: "Muy alto", color: "#157346", key: "very_high" };
}

// ── Global Score ─────────────────────────────────────────
export function calculateGlobalScore(anxietyScore, stressScore, wellbeingScore) {
  const anxNorm = (anxietyScore / 15) * 100;
  const strNorm = (stressScore / 20) * 100;
  const wbNorm = (wellbeingScore / 20) * 100;

  const anxInv = 100 - anxNorm;
  const strInv = 100 - strNorm;

  const global = (anxInv * 0.30) + (strInv * 0.30) + (wbNorm * 0.40);
  return Math.round(global);
}

export function classifyGlobal(score) {
  if (score <= 25) return { label: "Crítico", color: "#C0453A", key: "critical" };
  if (score <= 45) return { label: "Bajo", color: "#C0453A", key: "low" };
  if (score <= 65) return { label: "Moderado", color: "#F9A01B", key: "moderate" };
  if (score <= 80) return { label: "Bueno", color: "#157346", key: "good" };
  return { label: "Excelente", color: "#157346", key: "excellent" };
}

export function getMotivationalPhrase(key) {
  const phrases = {
    critical: "Es importante que busques apoyo. No tienes que enfrentar esto solo/a.",
    low: "Hay áreas que puedes mejorar. Pequeños pasos hacen gran diferencia.",
    moderate: "Vas por buen camino. Hay espacio para fortalecer tu bienestar.",
    good: "¡Bien hecho! Tienes buenos recursos emocionales.",
    excellent: "¡Excelente! Tu bienestar emocional es muy sólido.",
  };
  return phrases[key] || "";
}

// ── Score calculation helpers ────────────────────────────
export function sumScores(answers, options) {
  return answers.reduce((sum, val) => {
    const idx = options.indexOf(val);
    return sum + (idx >= 0 ? idx : 0);
  }, 0);
}
